"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = StaffPrivacyStatus;
const react_1 = __importStar(require("react"));
const privacyApi_1 = require("../../Privacy/privacyApi");
function StaffPrivacyStatus({ personId }) {
    const [status, setStatus] = (0, react_1.useState)(null);
    const [failed, setFailed] = (0, react_1.useState)(false);
    const [attempt, setAttempt] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        let cancelled = false;
        setStatus(null);
        setFailed(false);
        (0, privacyApi_1.personPrivacyStatus)(personId).then(value => {
            if (!cancelled)
                setStatus(value);
        }).catch(() => { if (!cancelled)
            setFailed(true); });
        return () => { cancelled = true; };
    }, [personId, attempt]);
    return react_1.default.createElement("div", { className: "mt-2 small", "aria-live": "polite" },
        react_1.default.createElement("strong", null, "Informacja o danych osobowych w PS"),
        react_1.default.createElement("div", null, failed ? react_1.default.createElement("span", { className: "text-danger" },
            "Nie uda\u0142o si\u0119 pobra\u0107 statusu. ",
            react_1.default.createElement("button", { type: "button", className: "btn btn-link btn-sm p-0", onClick: () => setAttempt(value => value + 1) }, "Spr\u00F3buj ponownie"))
            : !status ? react_1.default.createElement("span", { className: "text-muted" }, "Wczytywanie statusu...")
                : status.status === "missing" ? react_1.default.createElement("span", { className: "text-muted" }, "Brak potwierdzenia zapoznania si\u0119.")
                    : react_1.default.createElement(react_1.default.Fragment, null,
                        status.status === "confirmed" ? "Potwierdzono zapoznanie się: " : "Wymagane ponowne potwierdzenie. Poprzednie: ",
                        react_1.default.createElement("time", { dateTime: status.acknowledgedAt }, new Intl.DateTimeFormat("pl-PL", {
                            dateStyle: "short", timeStyle: "short", timeZone: "Europe/Warsaw",
                        }).format(new Date(status.acknowledgedAt))),
                        ".")));
}
